/* eslint-disable no-useless-escape */
export const EMAIL_REGEX =
  /^([a-z0-9!#$%&*+\-\/=?^_`'’{|}~.]{0,128}[a-z0-9]{1,128}@[a-z0-9\-.]{0,128}[a-z0-9]\.[a-z0-9]{2,63})?$/i;

export const NAME_REGEX = /[a-z]{2,}/i;

export const MAX_FILE_SIZE = 20000000;

export const MAX_FILE_COUNT = 25;

export const ALLOWED_FILE_TYPES =
  'pdf,bmp,png,gif,jpg,jpeg,plt,doc,docx,xls,xlsx,rtf,txt,csv,avi,mov,mp4,mpg,mpeg,wmv,gml,tif,tiff,zip,xml,json';
